<ul class="tabrow">
  @for (tab of tabs; track tab) {
    <li (click)="onTabClicked(tab)" [ngClass]="{'active': tab.active}">
      {{ tab.title }}
    </li>
  }
</ul>
<div class="tab-content">
  <ng-content></ng-content>
</div>